import { useEffect } from "react"


function Home() {
    useEffect(() => document.title = 'Home', [])

    return <>
        <center>This is home page.</center>
    </>
}


export default Home
